import { useQuery } from '@tanstack/react-query';
import sportsApi from '../../utils/sportsApi';
const key = 'PacingGoals';

type ClientGoalsInput = {
    clientId: string;
    enabled?: boolean;
};

const fetchClientGoals = async (clientId: string) => {
    const response: any[] = await sportsApi
        .url(`/clients/${clientId}/goals`)
        .json({
            action: 'fetchQuery',
            client: { id: clientId },
        })
        .post()
        .json();

    return response.filter(g => !g.archived);
};

const useClientGoals = ({ clientId, enabled = true }: ClientGoalsInput) =>
    useQuery({
        queryKey: [key, clientId],
        queryFn: () => fetchClientGoals(clientId),
        enabled: enabled && !!clientId, // prevent fetch if disabled or missing id
    });

export default useClientGoals;
